if (!customElements.get('sensic-tiktok')) customElements.define('sensic-tiktok', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    const dialog = this.querySelector('dialog'), player = this.querySelector('[data-tiktok-player]');
    const track = this.querySelector('[data-sv-slider-track]');
    let drag = null, suppressClick = false;
    track.addEventListener('pointerdown', event => {
      suppressClick = false;
      if (event.pointerType === 'touch' || event.button !== 0 || !event.target.closest('[data-tiktok-url]')) return;
      drag = { id: event.pointerId, x: event.clientX, scroll: track.scrollLeft, moved: false };
    });
    track.addEventListener('pointermove', event => {
      if (!drag || drag.id !== event.pointerId) return;
      const distance = event.clientX - drag.x;
      if (!drag.moved && Math.abs(distance) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      track.scrollLeft = drag.scroll - distance;
    });
    const endDrag = event => {
      if (!drag || drag.id !== event.pointerId) return;
      suppressClick = drag.moved;
      drag = null;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', endDrag);
    track.addEventListener('pointerleave', event => { if (drag && !drag.moved) endDrag(event); });
    track.addEventListener('click', event => {
      if (!suppressClick) return;
      event.preventDefault(); event.stopImmediatePropagation(); suppressClick = false;
    }, true);
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-tiktok-url]');
      if (button) {
        let url; try { url = new URL(button.dataset.tiktokUrl); } catch { return; }
        const id = url.pathname.match(/\/video\/(\d+)/)?.[1];
        if (!id || !['www.tiktok.com','tiktok.com'].includes(url.hostname)) return;
        const frame = document.createElement('iframe');
        frame.src = `https://www.tiktok.com/player/v1/${id}?autoplay=1&controls=1&description=0`;
        frame.title = button.getAttribute('aria-label'); frame.allow = 'autoplay; fullscreen'; frame.allowFullscreen = true;
        player.replaceChildren(frame); this.querySelector('[data-tiktok-original]').href = url.href;
        this.trigger = button; dialog.showModal();
      }
      if (event.target.closest('[data-tiktok-close]') || event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => { player.replaceChildren(); this.trigger?.focus(); });
  }
  disconnectedCallback() { this.querySelector('dialog')?.close(); }
});
